import { PagedResult } from 'types/apis'
import {WorkawareApi} from '../../apis/WorkawareApi'
import { transform, TransformMethods } from '../../data/transform'
import { EmailLogModel } from '../models/EmailLogModel'

export class emailLogService {

    private _api : WorkawareApi
    private emailLogTransform : TransformMethods<EmailLogModel>
    constructor(api: WorkawareApi){
        this._api = api
        this.emailLogTransform = transform<EmailLogModel>(EmailLogModel)
    }
    getList = (page: number, rowsPerPage: number, userEmail?: string) => {
        return new Promise<PagedResult<EmailLogModel>>((resolve, reject) => {
            this._api.emailLog.get(page, rowsPerPage)
            .then(result => {
                let values: EmailLogModel[] = this.emailLogTransform.arrayFrom(result.value)
                if (userEmail) {
                    values = values.filter(log =>
                        log.To?.toLowerCase().includes(userEmail.toLowerCase()) ||
                        log.From?.toLowerCase().includes(userEmail.toLowerCase())
                    )
                }
                resolve({
                    Count: userEmail ? values.length : result['@odata.count'] as number,
                    Values: values
                })
            })
            .catch(error => reject(error))
        })
    }
    resendEmail =(emailLogId:number) =>{
        return new Promise<any>((resolve,reject) =>{
            this._api.emailLog.resendEmail(emailLogId)
            .then(result =>resolve(result))
            .catch(error => reject(error))
        })
    }
    delete = (id: number) => {
        return new Promise<any>((resolve, reject) => {
            this._api.emailLog.delete(id)
                .then(result => resolve(result))
                .catch(error => reject(error))
        })
    }
}